export const downloadTxtFile = (content: string, filename: string) => {
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    element.style.display = 'none';
    document.body.appendChild(element); 
    element.click();
    document.body.removeChild(element);
  }